import React from "react";
import { Search, X } from "lucide-react";
import { STATUSES } from "./leadStatus";

export const LeadsFilterBar = ({ query, onQueryChange, statusFilter, onStatusFilterChange, packagerFilter, onClearPackagerFilter }) => (
  <div className="flex flex-col sm:flex-row sm:items-center gap-3 mb-6">
    <div className="relative flex-1 max-w-md">
      <Search size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#9CA3AF]" />
      <input
        value={query}
        onChange={(e) => onQueryChange(e.target.value)}
        placeholder="Search name, business, email, phone or amount…"
        data-testid="lead-search-input"
        className="w-full rounded-full border border-[#E5E7EB] bg-white pl-11 pr-4 py-2.5 text-sm outline-none focus:border-[#052F24]/40 transition-colors"
      />
    </div>
    <div className="flex items-center gap-1.5" data-testid="status-filter">
      {["All", ...STATUSES].map((s) => (
        <button
          key={s}
          onClick={() => onStatusFilterChange(s)}
          data-testid={`filter-${s.toLowerCase()}`}
          className={`rounded-full px-4 py-2 text-xs font-bold transition-colors ${
            statusFilter === s ? "bg-[#052F24] text-[#DFFF00]" : "bg-white border border-[#E5E7EB] text-[#052F24]/70 hover:border-[#052F24]/30"
          }`}
        >
          {s}
        </button>
      ))}
    </div>
    {packagerFilter && (
      <button
        onClick={onClearPackagerFilter}
        data-testid="active-packager-chip"
        className="flex items-center gap-1.5 rounded-full bg-[#DFFF00] text-[#052F24] px-4 py-2 text-xs font-bold hover:opacity-90 transition-opacity"
      >
        Packager: {packagerFilter} <X size={12} />
      </button>
    )}
  </div>
);
